import { chain, each, isObject } from 'lodash';
import { showNotification } from './notificationHelpers';
import { INTERNAL_SERVER_ERROR_KEY } from '../constants';

const showErrorNotification = (error, errorMessageKey) => {
  const errors = isObject(error.response.data.errors)
    ? Object.values(error.response.data.errors) : [INTERNAL_SERVER_ERROR_KEY];

  const backendErrors = chain(errors)
    .flatten()
    .uniq()
    .value();

  each(backendErrors, (e) => {
    showNotification(`backendErrors.${e}`, 'error', errorMessageKey);
  });
};

export default showErrorNotification;
